<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig"
  (rowAction)="onRowActions($event)"
></aur-mat-table>
